module.exports = __webpack_public_path__ + "img/aqtg-img02.7994fbfb.png";